import { httpsCallable } from 'firebase/functions';
import { functions } from '../constants/firebaseModular';
import type { SendAutomatedEmailPayload, SendAutomatedEmailResponse } from '@usacsmideo/types';
import * as Sentry from '@sentry/browser';

/**
 * Sends automated email to patient.
 * Updated Feb 2026 for new response pattern (no status envelope).
 */
export const sendAutomatedEmail = async (payload: SendAutomatedEmailPayload) => {
  // CHECK FOR REQUIRED FIELDS (type-specific validation)
  if (!payload.type) {
    Sentry.captureMessage(`Missing required field 'type' in payload ${JSON.stringify(payload)}`);
    return;
  }

  if (payload.type === 'apptReminder') {
    if (!payload.patientEmail || !payload.name) {
      Sentry.captureMessage(
        `Missing required fields in apptReminder payload ${JSON.stringify(payload)}`,
      );
      return;
    }
  } else {
    // cardInReview, cardReleased, or walletPassEmail
    if (!payload.email || !payload.name || !payload.patientId) {
      Sentry.captureMessage(
        `Missing required fields in ${payload.type} payload ${JSON.stringify(payload)}`,
      );
      return;
    }
  }

  // IF ALL CONDITIONS MET, CALL CLOUD FUNCTION TO SEND EMAIL
  const postToCloudFunction = httpsCallable<SendAutomatedEmailPayload, SendAutomatedEmailResponse>(
    functions,
    'sendAutomatedEmail',
  );

  try {
    await postToCloudFunction(payload);
    // ✅ Success = no error thrown, email sent
  } catch (error: any) {
    // Real errors come here (HttpsError from function)
    Sentry.captureException(error);
    console.error('Error sending automated email', error.code, error.message);
  }
};
